/**
 * Sprint 159 — La clave de un intento de captura (pedido o "Llegó más").
 *
 * Con la misma clave, el servidor reconoce un segundo envío del mismo intento y no lo repite.
 * `crypto.randomUUID` sólo existe en contextos seguros (HTTPS o localhost): si faltara, la
 * protección del servidor se apagaría sin avisar. Por eso hay un respaldo con
 * `crypto.getRandomValues`, que sí está en cualquier navegador moderno, armado como UUID v4.
 */
export function nuevaClaveIntento(): string | undefined {
  const c = typeof globalThis !== 'undefined' ? globalThis.crypto : undefined;
  if (!c) return undefined;
  if (typeof c.randomUUID === 'function') return c.randomUUID();
  if (typeof c.getRandomValues !== 'function') return undefined;
  const b = c.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
